export default __webpack_public_path__ + "static/media/1dad.c07ff76d.webp";